<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{ $t('auth.register') }}</h4>
                  <p>{{ $t('messages.register') }}</p>
                </div>
                <vs-tabs :value="locale">
                  <vs-tab @click="updateLocale('en')" :label="$t('general.english')">
                    <register-jwt></register-jwt>
                  </vs-tab>
                  <vs-tab @click="updateLocale('fa')" :label="$t('general.persian')">
                    <register-jwt></register-jwt>
                  </vs-tab>
                  <vs-tab @click="updateLocale('ar')" :label="$t('general.arabic')">
                    <register-jwt></register-jwt>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import RegisterJwt from './RegisterJWT.vue'

export default {
  components: {
    RegisterJwt
  },
  computed: {
    locale() {
      if (this.$i18n.locale === 'en') return 0
      else if (this.$i18n.locale === 'fa') return 1
      else if (this.$i18n.locale === 'ar') return 2
      return null
    }
  },
  methods: {
    updateLocale(locale) {
      if (locale === 'en') this.$vs.rtl = false
      else if (locale === 'fa') this.$vs.rtl = true
      else if (locale === 'ar') this.$vs.rtl = true
      localStorage.setItem('locale', locale)
      this.$i18n.locale = locale
    }
  },
  created() {
    if (this.$store.state.auth.isUserLoggedIn()) {
      this.$vs.notify({
        title: this.$t('messages.login_attempt'),
        text: this.$t('messages.already_logged_in'),
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      this.$router.push('/').catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
